import React from 'react'
import { BiCheckCircle } from 'react-icons/bi'
import RectangleImg  from '../Images/Service_Page/Rectangle 15.png'
import { Link } from 'react-router-dom'
import Ecl1 from '../Images/Service_Page/Ellipse 3.png'
import Ecl2 from '../Images/Service_Page/Ellipse 5.png'
import Ecl3 from '../Images/Service_Page/Ellipse 7.png'
import Ecl4 from '../Images/Service_Page/Ellipse 9.png'
import Ecl5 from '../Images/Service_Page/Ellipse 11.png'

function MainService() {
  return (
    <>
    <div className="ser--hero-container">

    <div className='center-text'>
    <h2 className='des-text'>
        We Provide Top Notch Services On 
    </h2> 
    <BiCheckCircle className='icon' />
    </div>

    <div className="hero--section">
        <div className='ser-link'>
            <Link to="/packages" className='ser--text'><h2>Graphic Design</h2></Link>
            <Link to="/packages" className='ser--text'><h2>Website Design</h2></Link>
            <Link to="/packages" className='ser--text'><h2>UI/UX Design</h2></Link>
        </div>
        <img src={RectangleImg} alt="" className='rec--img' />

        <div className='ecl--container'>
            <Link to="/packages"> <div className='ecl--circle'><img src={Ecl1} alt="" className='eclipse'/></div> </Link>
            <Link to="/packages"> <div className='ecl--circle'><img src={Ecl2} alt="" className='eclipse'/></div> </Link>
            <Link to="/packages"> <div className='ecl--circle'><img src={Ecl3} alt="" className='eclipse'/></div> </Link>
            <Link to="/packages"> <div className='ecl--circle'><img src={Ecl4} alt="" className='eclipse'/></div> </Link>
            <Link to="/packages"> <div className='ecl--circle'><img src={Ecl5} alt="" className='eclipse'/></div> </Link>
        </div>
        
    </div>


 
    </div>
    
    </>
  )
}

export default MainService